// Author Lin
// Date 2021-10-22 18:10:18

import * as model from "@/model/mintalMes/prd/MintalMesPrdPelletizingWaterSystemParameterModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdPelletizingWaterSystemParameter(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
